/**
 * Trigger a browser file-save for a blob of bytes. Wraps non-Blob data
 * in a Blob with the supplied `mimeType`, allocates an object URL,
 * synthesises a link click, then revokes the URL on the next tick.
 *
 * The single source of truth for "make the browser save these bytes" —
 * shared by `<DownloadButton>` (per-tile CSV) and the dashboard /
 * message "download all" buttons (multi-tile ZIP).
 */
export function triggerBlobDownload(
  data: string | Blob | Uint8Array | ArrayBuffer,
  fileName: string,
  mimeType: string,
): void {
  // The Blob constructor accepts `BlobPart`, which is narrower in
  // strict TS (`ArrayBufferView<ArrayBuffer>`) than `Uint8Array`'s
  // declared shape (`Uint8Array<ArrayBufferLike>`). The runtime accepts
  // every Uint8Array; the cast bridges the strictness gap at this
  // single boundary.
  const blob = data instanceof Blob ? data : new Blob([data as BlobPart], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  anchor.click();
  URL.revokeObjectURL(url);
}
